// A phone held sideways is 360 CSS px tall or less. The argument's desk (the case, whose turn, the paper, the answer,
// the Speak button) needs more than that under the bench, and the page never scrolls, so the controls were simply
// off the bottom of the screen. The fix is a sign over the room that asks for the phone to be turned, shown only
// while the device itself is sideways: an open keyboard also makes a portrait phone wider than tall, and that
// must not raise it, so the question goes to screen.orientation and not to the viewport.
import { useEffect, useState } from 'react';
import './turn-upright.css';

const SIDEWAYS_PHONE = '(pointer: coarse) and (orientation: landscape) and (max-height: 500px)';

function deviceIsSideways(): boolean {
  try {
    if (!window.matchMedia(SIDEWAYS_PHONE).matches) return false;
    const type = window.screen?.orientation?.type;
    // No orientation API (older iOS): the viewport is all there is to go on.
    return type ? type.startsWith('landscape') : true;
  } catch {
    return false;
  }
}

export default function TurnUpright() {
  const [sideways, setSideways] = useState(deviceIsSideways);
  useEffect(() => {
    const check = () => setSideways(deviceIsSideways());
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);
  if (!sideways) return null;
  return (
    <div className="turn-upright" role="alert" data-testid="turn-upright">
      <svg className="turn-upright-phone" viewBox="0 0 12 20" width="36" height="60" aria-hidden="true" shapeRendering="crispEdges">
        <rect x="0" y="0" width="12" height="20" fill="#a89f92" />
        <rect x="1" y="1" width="10" height="16" fill="#160f1a" />
        <rect x="2" y="2" width="8" height="14" fill="#fffbf2" />
        <rect x="2" y="4" width="8" height="2" fill="#8f1c28" />
        <rect x="3" y="7" width="6" height="1" fill="#565068" />
        <rect x="3" y="10" width="6" height="1" fill="#565068" />
        <rect x="4" y="18" width="4" height="1" fill="#565068" />
      </svg>
      <p className="turn-upright-text paper">Turn your phone upright.</p>
    </div>
  );
}
